var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"p-5"},[(!_vm.showDashboard)?_c('OnBoarding',{on:{"to-dashboard":_vm.goToDashboard}}):_vm._e(),(_vm.showDashboard)?_c('Dashboard'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }